// Enum: swf.exporters.swflite.timeline.FrameObjectType

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../../../estr_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;

// Definition

var FrameObjectType = $hxEnums["swf.exporters.swflite.timeline.FrameObjectType"] = { __ename__ : "swf.exporters.swflite.timeline.FrameObjectType", __constructs__ : ["CREATE","UPDATE","DESTROY"]
  ,UPDATE: {_hx_index:1,__enum__:"swf.exporters.swflite.timeline.FrameObjectType",toString:$estr}
  ,DESTROY: {_hx_index:2,__enum__:"swf.exporters.swflite.timeline.FrameObjectType",toString:$estr}
  ,CREATE: {_hx_index:0,__enum__:"swf.exporters.swflite.timeline.FrameObjectType",toString:$estr}
};

exports.default = FrameObjectType;